import { SACBaseService } from "./SACBaseService";
let savedData = {
    firstName: "",
    lastName: "",
    token: "",
    teacherId: "",
};
export class SACBackendService extends SACBaseService {
    constructor(fetchImpl) {
        super(process.env.SAC_ENDPOINT ?? "", fetchImpl, (data) => {
            savedData = data;
        }, () => savedData);
    }
}
